<template>
  <div class="item-unit-modal">
    <form action="" @submit.prevent="submitAttachment">
      <div class="card-body">
        <div class="form-group row">
          <label class="col-sm-4 col-form-label input-label">{{ $t('documents.documentType') }}  <span class="required"> *</span> </label>
          <div class="col-sm-7">
            <base-select
                v-model="attachmentData.documentType"
                :options="profileDocumentTypes"
                :searchable="true"
                :show-labels="false"
                label="name"
                @input="$v.attachmentData.documentType.$touch()"
            >
            </base-select>
            <div v-if="$v.attachmentData.documentType.$error">
              <span v-if="!$v.attachmentData.documentType.required" class="form-group__message text-danger">{{ $tc('validation.required') }}</span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-4 col-form-label input-label">{{ $t('documents.document') }} <span class="required"> *</span></label>
          <div class="col-sm-7">
           <input ref="file" @change="onFileChange" type="file"
            @input="$v.attachmentData.file.$touch()"
            >
            <span class="form-group__message text-danger">{{  $t('documents.documentSizelessthan5MB') }}</span>
            <div v-if="$v.attachmentData.file.$error">
              <span v-if="!$v.attachmentData.file.required" class="form-group__message text-danger">{{ $tc('validation.required') }}</span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-4 col-form-label input-label">{{ $t('documents.note') }}</label>
          <div class="col-sm-7">
           <base-text-area
           v-model="attachmentData.description"
           />
          </div>
        </div>
      </div>
      <div class="card-footer">
        <base-button
          :outline="true"
          class="mr-3"
          color="theme"
          type="button"
          @click="closeAttachmentModal"
        >
          {{ $t('general.cancel') }}
        </base-button>
        <base-button
          :loading="isLoading"
          color="theme"
          icon="save"
          type="submit"
        >
          {{ $t('general.save') }}
        </base-button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
const { required, minLength } = require('vuelidate/lib/validators')
export default {
  mixins: [validationMixin],
  data () {
    return {
      file:null,
      documentTypes:[],
      selectedCompany:null,
      selectedFile:null,
      isLoading: false,
      attachmentData: {
        documentType: null,
        file: null,
        description:null,
      }
    }
  },
  computed: {
    ...mapGetters('modal', [
      'modalDataID',
      'modalData',
      'modalActive'
    ]),
    ...mapGetters('documentType', [
        'profileDocumentTypes'
    ])

  },
  created(){
    if(localStorage.getItem('selectedCompany')){
       this.selectedCompany=localStorage.getItem('selectedCompany');
    }
  },
  validations: {
    attachmentData: {
        documentType: {
            required,
        },
        file: {
            required,
        },
    }
  },
  async mounted () {
  },
  methods: {
    ...mapActions('modal', [
      'closeModal',
      'resetModalData'
    ]),
    ...mapActions('documentType', [
      'addCompanyAttachment',
      'fetchCompanyAttachments'
    ]),
    onFileChange (e) {
       if(e.target.files[0].size >=1048576*5){
          window.toastr['error'](this.$t('documents.documentSizeExceed5MB'));
          this.$refs.file.value = '';
        }else{
          this.selectedFile = e.target.files[0];
          this.attachmentData.file=e.target.files[0];
       }
    },
    resetFormData () {
       this.attachmentData= {
        documentType: null,
        file: null,
        description:null
      }
      this.$v.attachmentData.$reset()
    },
    async submitAttachment () {
      this.$v.attachmentData.$touch()
      if (this.$v.$invalid) {
        return true
      }

      let data = new FormData();
      data.append('selectedCompany', this.selectedCompany);
      data.append('document_type_id',this.attachmentData.documentType.id);
      data.append('document', this.selectedFile)
      data.append('description', this.attachmentData.description)

      let res =await this.addCompanyAttachment(data)

      if(res.data.result=='success'){
         this.Attachments()
      }

      this.closeAttachmentModal()
    },
    closeAttachmentModal () {
      this.resetModalData()
      this.resetFormData()
      this.closeModal()

    },
    async Attachments(){
        const data = {
            id: this.selectedCompany
        }
        let response = await this.fetchCompanyAttachments(data)
        this.isRequestOngoing = false
    },
  }
}
</script>
